module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showPopup ? 'show' : '',
    attrs: {
      "id": "discountPopup"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "ticket"
  }, [_c('div', {
    staticClass: "ticket-border-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "ticket-content"
  }, [_c('p', {
    staticClass: "top"
  }, [_vm._v("Take an extra discount")]), _vm._v(" "), _c('h1', [_vm._v("10% OFF")]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "margin": "5px 0 15px"
    }
  }, [_vm._v("For orders above 10£")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('b-button', {
    staticClass: "btn-danger btn-fill",
    on: {
      "click": _vm.setDiscount
    }
  }, [_vm._v("Use Now")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ticket-border-right"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Voucher code")]), _c('br'), _vm._v("\n          V21CU23\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c839584!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discount-popup.vue
// module id = 548
// module chunks = 1